export default "__VITE_ASSET__Sz86IKQd__"